import React from 'react';
import autobind from 'autobind-decorator';

import services from 'core/services';
import { PureComponent, Page, Loading } from 'core/components';
import { withLocale } from 'core/decorators';
import { Product } from 'content/components'

import translations from './i18n';

class ProductPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      galleryLoading: false,
      item: null,
      gallery: [],
      cover: null,
      photos: []
    };

    this.props.translator.addModuleResource('product', translations);
  };

  /**
   * @inheritdoc
   */
  componentDidMount() {
    const { id } = this.props;

    this.loading(true);

    const params = {
      store: 2
    }

    services.ecommerce.Product.getProductDetail(id, params)
      .then(r => {
        this.setState({
          item: r.data.product
        })

        this.getGallery(r.data.product.id)
      })
      .catch(e => {

      })
      .finally(r => {
        this.loading(false)
      })
  };

  getGallery(id) {
    this.galleryLoading(true)

    services.ecommerce.Product.getGallery(id, { store: 2 })
      .then(r => {
        // console.log('getGallery:', r.data)
        this.setState({
          gallery: r.data.gallery,
          cover: r.data.cover,
        }, () => {
          this.showPhotos()
        })
      })
      .catch(e => {
        this.setState({
          gallery: null
        })
      })
      .finally(r => {
        this.galleryLoading(false)
      })
  }

  showPhotos() {
    const { cover, gallery } = this.state;

    var photos = []

    if (cover) {
      photos.push({
        url: cover.url,
        caption: cover.description
      })
    }

    if (gallery) {
      gallery.map(g => {
        if (!g.image) return

        photos.push({
          url: g.image.url,
          caption: g.image.description,
        })
      })
    }


    this.setState({
      photos,
    })
  }

  /**
   * handle loading
   * @param {Boolian} loading 
   */
  loading(loading = false) {
    this.setState((prevState, props) => {
      return { loading: loading }
    });
  };

  galleryLoading(loading = false) {
    this.setState((prevState, props) => {
      return { galleryLoading: loading }
    });
  };

  render() {
    const { navigate } = this.props;
    const { item, gallery, cover, loading, galleryLoading, photos } = this.state;

    return (
      <Page
        pageName="product"
        showCart={true}
        showSearch={true}
        showBack={true}
        navigate={navigate}
      >
        {loading || galleryLoading ?
          <Loading height={70} />
          :
          <Product
            item={item}
            photos={photos}
            // gallery={gallery}
            // cover={cover}
            loading={galleryLoading}
            navigate={navigate}
          />
        }
      </Page>
    );
  };
};

export default withLocale('product')(autobind(ProductPage));
